"use strict";

exports.__esModule = true;
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const schema = {
  Id: {
    displayName: 'ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true
  },
  Title: {
    displayName: 'Title',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  TitleTranslationId: {
    displayName: 'Title translation ID',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  TitleDisplayText: {
    displayName: 'Title display text',
    type: 'String',
    value: '',
    sortable: true,
    filterable: true
  },
  Text: {
    displayName: 'Text',
    type: 'RichText',
    rules: [],
    value: '',
    sortable: true,
    filterable: false
  },
  TextTranslationId: {
    displayName: 'Text translation ID',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  TextDisplayText: {
    displayName: 'Text display text',
    type: 'RichText',
    value: '',
    sortable: true,
    filterable: false
  },
  Optional: {
    displayName: 'Optional',
    type: 'Bool',
    rules: [],
    value: false,
    sortable: true,
    filterable: true
  },
  CreatedAt: {
    displayName: 'Created',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    guarded: true,
    sortable: true,
    filterable: true
  },
  UpdatedAt: {
    displayName: 'Updated',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    guarded: true,
    sortable: true,
    filterable: true
  }
};
var _default = exports.default = schema;
module.exports = exports.default;